import { useEffect } from "react";
import { connect } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import {
  fetchReservationsByLocationAndNetwork,
  initializeReservationsByLocationAndNetworkScreen,
  exportReservationsByLocationAndNetwork,
  setReservationsByLocationAndNetworkFilters,
  clearReservationsByLocationAndNetworkFilters,
} from "../../../redux/actions/Reservations/ReservationsByLocationAndNetwork";
import { fetchLocationDD } from "../../../redux/actions/location";
import { fetchRateAdminNetworkDD } from "../../../redux/actions/RateAdmin/rateadminRates";
import ReservationsByLocationAndNetwork from "../../../component/Reservations/ReservationsByLocationAndNetwork";
import { loadingShow } from "../../../services/PostAPI";
import { ProgressBar } from "primereact/progressbar";

let cachedFilters = null;

function ReservationsByLocationAndNetworkScreen(props) {
  const {
    fetchReservationsByLocationAndNetwork,
    initScreen,
    ReservationsByLocationAndNetworkListview,
    paginationInfo,
    exportReservationsByLocationAndNetwork,
    isExportError,
    isExportSuccess,
    isLoading,
    fetchLocationDD,
    fetchRateAdminNetworkDD,
    RateNetworkDD,
    locationDD,
    filters,
    setFilters,
    clearFilters,
    showPageLevelLoader,
  } = props;

  const setFiltersWithCache = (f) => {
    cachedFilters = f;
    setFilters(f);
  };

  useEffect(() => {
    fetchRateAdminNetworkDD();
    fetchLocationDD();
  }, []);

  useEffect(() => {
    initScreen();
  }, []);

  const loadLazyData = (payload) => {
    const newPayload = {
      ...payload,
      additinalFilter: payload.additinalFilter ?? cachedFilters,
    };
    fetchReservationsByLocationAndNetwork(newPayload);
  };

  const handleExport = (payload) => {
    const exportPayload = {
      ...payload,
      additinalFilter: payload?.additinalFilter ?? cachedFilters,
    };
    exportReservationsByLocationAndNetwork(exportPayload);
  };

  const componentProps = {
    fetchReservationsByLocationAndNetwork: loadLazyData,
    exportReservationsByLocationAndNetwork: handleExport,
    isExportError,
    isExportSuccess,
    tableData: {
      columns: ReservationsByLocationAndNetworkListview?.columns,
      rows: ReservationsByLocationAndNetworkListview?.rows,
    },
    paginationInfo: {
      pageSize: paginationInfo?.pageSize,
      pageNumber: paginationInfo?.pageNumber,
      totalPages: paginationInfo?.totalPages,
      totalRecords: paginationInfo?.totalRecords,
    },
    isLoading,
    RateNetworkDD,
    locationDD,
    filters,
    setFilters: setFiltersWithCache,
    clearFilters,
  };

  if (showPageLevelLoader) {
    loadingShow("block");
    return null;
  }
  loadingShow("none");

  return (
    <div>
      {isLoading && (
        <ProgressBar mode="indeterminate" style={{ height: "6px" }} />
      )}
      <ReservationsByLocationAndNetwork {...componentProps} />
    </div>
  );
}

const mapDispatchToProps = (dispatch) => ({
  initScreen: () =>
    dispatch(initializeReservationsByLocationAndNetworkScreen()),
  fetchReservationsByLocationAndNetwork: (payload) =>
    dispatch(fetchReservationsByLocationAndNetwork(payload)),
  fetchRateAdminNetworkDD: (payload) =>
    dispatch(fetchRateAdminNetworkDD(payload)),
  fetchLocationDD: (payload) => dispatch(fetchLocationDD(payload)),
  exportReservationsByLocationAndNetwork: (payload) =>
    dispatch(exportReservationsByLocationAndNetwork(payload)),
  setFilters: (f) =>
    dispatch(setReservationsByLocationAndNetworkFilters(f)),
  clearFilters: () =>
    dispatch(clearReservationsByLocationAndNetworkFilters()),
});

const mapStateToProps = (state) => ({
  isLoading: state.ReservationsByLocationAndNetworkReducer?.isLoading,
  ReservationsByLocationAndNetworkListview:
    state.ReservationsByLocationAndNetworkReducer
      ?.ReservationsByLocationAndNetworkListview,
  showPageLevelLoader:
    state.ReservationsByLocationAndNetworkReducer?.isLoadingPage,
  paginationInfo:
    state.ReservationsByLocationAndNetworkReducer?.paginationInfo,
  isExportError:
    state.ReservationsByLocationAndNetworkReducer?.isExportError,
  isExportSuccess:
    state.ReservationsByLocationAndNetworkReducer?.isExportSuccess,
  RateNetworkDD: state.rateadminRatesReducer?.RateNetworkDD,
  locationDD: state.locationReducer?.locationDD,
  filters: state.ReservationsByLocationAndNetworkReducer?.filters,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ReservationsByLocationAndNetworkScreen);
